module.exports = __webpack_public_path__ + "img/RoadRoller.b6d03dba.png";